import React, { useEffect, useState } from 'react';
import './FAQ.css';
import Header from './Header';
import Footer2 from './Footer2';

const FAQ = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const faqs = [
        {
            question: "Do you accept commissioned work?",
            answer: "Yes, we do accept custom commissions! Please fill the form below for all the custom requirements."
        },
        {
            question: "Is the artwork framed?",
            answer: "Unless specified for glass painting and canvas painting, otherwise all the products are as per custom requirement either they can be framed or can be hung on wall."
        },
        {
            question: "How can I see how a piece looks in my room?",
            answer: "I provide 'in-room' mockups for all major works to give a look. If you are still unsure, feel free to Contact Me with a photo of your wall, and I can digitally place the artwork for you."
        },
        {
            question: "Do you ship internationally?",
            answer: "Yes, we ship worldwide. Please note that international buyers are responsible for any customs duties or taxes incurred upon entry into their country."
        },
        {
            question: "How long will it take to receive my order?",
            answer: "Please read our shopping terms page for detailed information on delivery timelines."
        },
        {
            question: "What is your return policy?",
            answer: "We want you to love your new art as the art piece will be completely customized as per requirement. So we don’t offer any return policy but in such specific case piece need to be returned then Return shipping costs are the responsibility of the buyer."
        },
        {
            question: "Does the art come with a Certificate of Authenticity?",
            answer: "Yes, every original painting and art piece includes a signed and dated Certificate of Authenticity to ensure its future value and provenance."
        },
        {
            question: "What should I do if my order arrives damaged?",
            answer: "Please inspect your package immediately upon arrival. In the rare event of damage, take photos and videos of the packaging and the artwork and Contact us within 24 hours so we can file an insurance claim and arrange a replacement or repair."
        }
    ];

    return (
        <>
            <Header />

            <div className="faq-main-wrapper">
                <div className="container">
                    <div className="faq-list-container">
                        <h1 className="faq-page-title">FAQs</h1>

                        {faqs.map((faq, index) => (
                            <div key={index} className="faq-card-item">
                                <h3 className="faq-question-heading">{faq.question}</h3>
                                <p className="faq-answer-paragraph">{faq.answer}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <Footer2 />
        </>
    );
};

export default FAQ;